import type { WLatestRealizationsTranslations } from "./pl";

export const de: WLatestRealizationsTranslations = {
  readMore: "Ansehen",
  showAll: "Alle Projekte",
  defaultTitle: "Weitere Projekte ansehen",
};
